import { render, staticRenderFns } from "./AssignGroupDialog.vue?vue&type=template&id=040b3756&scoped=true&"
import script from "./AssignGroupDialog.vue?vue&type=script&lang=js&"
export * from "./AssignGroupDialog.vue?vue&type=script&lang=js&"
import style0 from "./AssignGroupDialog.vue?vue&type=style&index=0&id=040b3756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040b3756",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDatePicker,VIcon,VMenu,VSelect,VSimpleTable,VTextField})
